import { buildAdminAppResult } from './admin/buildAdminAppResult'
import { API_BASE } from './admin/constants'
import { useAdminAppModel } from './admin/useAdminAppModel'

function useAdminApp() {
  return buildAdminAppResult({
    apiBase: API_BASE,
    ...useAdminAppModel(),
  })
}

export type AdminAppState = ReturnType<typeof useAdminApp>

export default useAdminApp
